import React, { useState } from "react";

const FAQs = () => {
  const faqs = [
    {
      question: "Is the program safe?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut orci vitae urna dapibus luctus.",
    },
    {
      question: "Are there any side effects?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, dolores!",
    },
    {
      question: "How soon will I see results?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur feugiat quam eget nisl pretium.",
    },
    {
      question: "Can I cancel my program?",
      answer:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit perspiciatis, tempore officia suscipit.",
    },
    {
      question: "Will I gain the weight back after the program?",
      answer:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, veritatis!",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-[#FAFAFA] py-16 font-poppins">
      <div className="max-w-4xl mx-auto px-4 md:px-6 font-poppins">
        <h2 className="text-[32px] md:text-[36px] lg:text-[48px] font-bold text-[#2A3342]  text-center mb-10">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3">
          {faqs.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-slate-200 shadow-sm"
            >

              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-3.5 text-left text-[16px] text-[#2A3342] transition font-medium"
              >
                <span>{item.question}</span>
                <ChevronDownIcon isOpen={openIndex === index} />
              </button>


              {openIndex === index && (
                <div className="px-5 pb-4 text-[13px] text-slate-500 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ChevronDownIcon = ({ isOpen }) => (
  <svg
    className={`h-4 w-4 text-[#2A3342]  transition-transform ${isOpen ? "rotate-180" : ""
      }`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FAQs;
